export default "__VITE_ASSET__NgmECeGs__"